var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaleTips3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1643",
    "data-name": "Group 1643",
    transform: "translate(-372 -514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_44",
    "data-name": "Polygon 44",
    d: "M56.843,9.117a10,10,0,0,1,15.315,0l.028.033a10,10,0,0,0,11.45,2.822l.041-.017a10,10,0,0,1,13.562,7.118l.007.034a10,10,0,0,0,8.829,7.821l.038,0a10,10,0,0,1,8.7,12.608l-.007.026A10,10,0,0,0,118.99,50.6l.024.016a10,10,0,0,1,1.847,15.209l-.018.019a10,10,0,0,0-1.422,11.713l.012.022A10,10,0,0,1,114,91.9l-.031.011a10,10,0,0,0-6.7,9.708v.03A10,10,0,0,1,95.8,111.805l-.041-.006a10,10,0,0,0-10.443,5.48l-.017.035a10,10,0,0,1-14.87,3.665l-.036-.026a10,10,0,0,0-11.792,0l-.036.026a10,10,0,0,1-14.87-3.665l-.017-.035a10,10,0,0,0-10.443-5.48l-.041.006a10,10,0,0,1-11.465-10.158v-.03a10,10,0,0,0-6.7-9.708L15,91.9A10,10,0,0,1,9.567,77.574l.012-.022A10,10,0,0,0,8.157,65.839l-.018-.019A10,10,0,0,1,9.986,50.611l.024-.016a10,10,0,0,0,4.184-11.031l-.007-.026a10,10,0,0,1,8.7-12.608l.038,0a10,10,0,0,0,8.829-7.821l.007-.034a10,10,0,0,1,13.562-7.118l.041.017A10,10,0,0,0,56.815,9.15Z",
    transform: "translate(372 514)",
    fill: "#fc4b77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626",
    transform: "translate(21 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boy-calling-on-mobile-phone",
    transform: "translate(387.825 558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M748.479,343.816s-.748-.322-.892.355,1.672,2.641,1.672,2.641Z",
    transform: "translate(-700.369 -330.243)",
    fill: "#f17b98"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1617",
    "data-name": "Group 1617",
    transform: "translate(27.14 18.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M494.615,458.555c.213,1.85.374,3.555.4,4.661H464.154a6.967,6.967,0,0,1-1.542-4.088c.173-2.355.811-5.534.8-6.71a49.232,49.232,0,0,0-.692-7.457,34.135,34.135,0,0,0-2.487-7.361c-.4-.989-.809-1.983-1.116-3a7.383,7.383,0,0,1-.386-2.564,5.9,5.9,0,0,1,.274-1.45c.162-.314.339-.624.535-.928,1.984-3.038,5.352-4.847,8.231-6.912a1.1,1.1,0,0,0,.218-.2l.562-.388.056-.038c.756-2.947,1.923-4.135,2.9-4.732.84-.515,7.992-4.584,12.7-4.433s5.329,4.065,4.956,5.834a4.765,4.765,0,0,0,.825,4.3c.994,1.362.281,3.785.281,3.785a11.456,11.456,0,0,1,5.377,3.482,54.542,54.542,0,0,1,5.627,8.989c.753,1.584-7.759,10.188-7.93,9.622C493.374,449.276,494.129,454.3,494.615,458.555Z",
    transform: "translate(-458.719 -412.946)",
    fill: "#87cbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M640.271,430.643s2.089-2.067,3.84-3.456,1.961-3.643.384-4.608-7.3.576-7.3.576l1.706,5.358Zm-11.136,2.88s-1.043-5.888,1.344-6.912c2.5-1.074,3.019.092,3.019.092l-.159,3.921Z",
    transform: "translate(-617.083 -421.614)",
    fill: "#368181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M737.58,558.259a.294.294,0,0,1-.174-.533,72.066,72.066,0,0,1,9.109-5.5.294.294,0,0,1,.247.534,71.445,71.445,0,0,0-9.014,5.449A.293.293,0,0,1,737.58,558.259Z",
    transform: "translate(-717.928 -542.519)",
    fill: "#7fa9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M514.29,549.463a.293.293,0,0,1-.162-.067l-2.626-2.181a.294.294,0,0,1,.376-.452l2.626,2.181a.294.294,0,0,1-.213.519Zm-19.021.8a10.284,10.284,0,0,1-1.242-4.8c-.091.063-.287.2-.564.387l-.024.029a10.877,10.877,0,0,0,1.32,4.683.293.293,0,0,0,.258.147.3.3,0,0,0,.145-.041A.3.3,0,0,0,495.269,550.266Zm16.149,30.1c-4.492-1.827-6.688-8.251-6.71-8.316a.392.392,0,0,0-.368-.268l-10.977-.091a.4.4,0,0,0-.387.311,15.358,15.358,0,0,1-2.629,5.27.384.384,0,0,0,.091.535l.006,0a.386.386,0,0,0,.544-.08,16.675,16.675,0,0,0,2.681-5.254l10.389.086c.468,1.266,2.637,6.551,6.813,8.421l-.235,4.333a.39.39,0,0,0,.364.413h.032a.392.392,0,0,0,.387-.371l.25-4.608A.4.4,0,0,0,511.418,580.37Zm-22.053-12.436a38.132,38.132,0,0,0-2.634-10.315c-.162-.385-.751-.1-.61.3a46.328,46.328,0,0,1,2.531,10.631,72.666,72.666,0,0,1-.221,11.8c-.039.558.736.539.775-.015A70.181,70.181,0,0,0,489.365,567.935Z",
    transform: "translate(-484.198 -536.256)",
    fill: "#7fa9a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619",
    transform: "translate(31.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M510.458,154.449s-5.509-2.448-5.1-7.141c.1-1.1.43-2.367,1.609-2.752a3.716,3.716,0,0,1,1.167-.132c.373,0,.614.027.683-.432a4.993,4.993,0,0,1,.066-.62.975.975,0,0,1,.763-.653,1.465,1.465,0,0,1,1.012.217c.228.138.478.332.731.247a.744.744,0,0,0,.341-.321,2.717,2.717,0,0,1,.582-.687,1.49,1.49,0,0,1,1.108-.252,2.069,2.069,0,0,1,1.033.507c.2.175.371.381.574.55.375.312.62.238,1.053.247.681.015,1.184.642,1.514,1.17.143.229,5.933-.318,6.943,3.522.542,2.06-.982,9.906-.982,9.906Z",
    transform: "translate(-505.336 -141.906)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M642.2,345.719s-1.108,1.059-2.467,2.345c-1.391,1.318-3.043,2.872-4.041,3.769-1.972,1.775-4.142,2.761-5.325,1.775-.83-.692-.98-3.815-1-5.613-.008-.765.01-1.29.01-1.29a5.266,5.266,0,0,0,2.168-1.6,1.431,1.431,0,0,0,.2-.373,3.414,3.414,0,0,0,0-2.17l3.694-3.586,3.261-6.5s-.249,8.5.934,10.477A8.1,8.1,0,0,0,642.2,345.719Z",
    transform: "translate(-621.801 -319.767)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M660.732,432.116a1.435,1.435,0,0,0,.2-.373,3.415,3.415,0,0,0,0-2.17l3.694-3.586,1.631.233A5.7,5.7,0,0,1,660.732,432.116Z",
    transform: "translate(-650.989 -406.777)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M589.543,285.394a1.293,1.293,0,0,0-2.1-.139,4.588,4.588,0,0,0-.71.871c-.145.223-.259.7-.624.516-.306-.151-.53-.613-.748-.863a10.644,10.644,0,0,0-.856-.7,7.557,7.557,0,0,0-.853-.886c-.632-.419-1.528-.21-2.17-.613a2.142,2.142,0,0,0-.5-.3,1.484,1.484,0,0,0-.87.159,2.928,2.928,0,0,1-2.432-.257.458.458,0,0,0-.349-.1.42.42,0,0,0-.153.1,4.916,4.916,0,0,1-2.207,1.22c.023.557.074,1.092.139,1.641.113.94-.009,8.241,1.988,10.231,1.055,1.051,3.723,1,4.976.761,2.894-.545,5-2.1,5.8-4.576a5.9,5.9,0,0,0,.2-2.38S591.573,288.1,589.543,285.394Z",
    transform: "translate(-570.13 -273.257)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M586.352,336.562a.442.442,0,0,1,.356-.171l.047,0a.084.084,0,0,1,.017,0l.016,0c.476.015.649.653.446,1.029a.393.393,0,0,1-.137.225.444.444,0,0,1-.257.084.1.1,0,0,1-.024.012.4.4,0,0,1-.477-.241A.73.73,0,0,1,586.352,336.562Z",
    transform: "translate(-577.783 -322.872)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M580.008,301.792c.4.146,1.547.576,1.935.761.349.167.119.726-.233.558-.387-.185-1.538-.615-1.935-.761C579.409,302.215,579.643,301.657,580.008,301.792Z",
    transform: "translate(-571.926 -290.664)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M636.529,426.3a5.355,5.355,0,0,0,.09-.757c.006-.122-.01-.274-.123-.32a.311.311,0,0,0-.192.006,21.886,21.886,0,0,0-2.327.65.375.375,0,0,0-.018.3,2.028,2.028,0,0,0,1.667,1.53c.537,0,.677-.53.8-.963Q636.486,426.525,636.529,426.3Z",
    transform: "translate(-626.91 -405.526)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618",
    transform: "translate(7.565 28.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M639.756,555.84c-1.391,1.317-3.043,2.872-4.041,3.769-1.972,1.775-4.142,2.761-5.325,1.775-.83-.692-.98-3.815-1-5.613C630.318,556.362,633.537,557.9,639.756,555.84Z",
    transform: "translate(-629.393 -555.771)",
    fill: "#368181"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M887.146,746.018c6.1,7.469,9.744,13.443,6.638,19.835-1.254,2.58-9.857,7.5-12.545,6.257s-5.075-13.795-5.075-13.795Z",
    transform: "translate(-820.018 -704.57)",
    fill: "#87cbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M950.282,657.593a.351.351,0,0,1-.309-.183c-.073-.134-7.313-13.439-10.929-19.754a.351.351,0,0,1,.609-.349c3.62,6.322,10.864,19.634,10.936,19.768a.351.351,0,0,1-.308.519Z",
    transform: "translate(-878.488 -603.248)",
    fill: "#7fa9a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "girl-speaking-on-smartphone",
    transform: "translate(195.273 397.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M708.2,625.987c1.275.967,1.457,1.547,1.457,2.32a2.659,2.659,0,0,0,1.479,1.981h9.449c.911-.627-3.461-14.356-4.189-14.162s-7.573-13.193-9.146-15.117c-1.236-1.512-7.246-5.186-7.246-5.186l6.01,26.877A9.172,9.172,0,0,0,708.2,625.987Z",
    transform: "translate(-492.694 -401.302)",
    fill: "#116a6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M180.15,504.884h32.969a3.493,3.493,0,0,0-.795-1.99c-.831-.831-.623-3.867-.208-4.7s2.7-3.53,2.49-6.02-1.244-5.606-1.659-10.8-4.256-8.3-4.455-10.143c-.637-5.919-4.894-9.365-15.482-8.743,0,0-6.739.911-6.375,3.1.275,1.651,1.872,2.422,1.457,3.461s-2.914,3.279.364,5.282c-.049.036-2.483,1.759-2.869,2.084a8.472,8.472,0,0,0-.976.971c-.075.086-.146.173-.215.26a8.542,8.542,0,0,0-.914,1.43,20.082,20.082,0,0,0-.967,2.59c-.637,1.858-1.229,3.732-1.876,5.586-.29.829-.586,1.654-.922,2.464a8.547,8.547,0,0,1-.816,1.626c-1.452,2.075-4.359,5.189-2.282,8.3C177.918,501.6,179.3,504.489,180.15,504.884Z",
    transform: "translate(0 -275.898)",
    fill: "#368181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M217.359,668.038c-1.191,1.091-1.97,2.554-3.164,3.67-1.231,1.151-2.593,2.165-3.719,3.426a28.841,28.841,0,0,0-2.493,3.669,13.814,13.814,0,0,0-6.267,4.013c-.165.184.1.457.273.273a14.4,14.4,0,0,1,5.655-3.779,20.361,20.361,0,0,1-3.787,3.989c-.333.277.113.865.468.606a17.311,17.311,0,0,0,3.539-3.5c1.116-1.463,1.882-3.172,3.085-4.569a41.408,41.408,0,0,1,3.579-3.335,14.927,14.927,0,0,0,1.778-1.892,18.934,18.934,0,0,1,1.557-2.068C218.188,668.217,217.695,667.731,217.359,668.038Zm1.754,19.928c1.476-3.085,5.378-9.054,5.134-8.787-1.583,1.727-5.868,6.188-8.605,8.787ZM239.4,675.272c-.224-1.528-.609-3.025-.864-4.547-.293-1.745-3.673-9.327-3.77-11.091a.339.339,0,0,0-.678,0c-.147,2.894,3.7,11.517,4.254,14.338a10.812,10.812,0,0,1,.285,4.519,15.6,15.6,0,0,1-.971,2.637c.157.288.329.567.51.84.407-.908.79-1.83,1.1-2.768A8.335,8.335,0,0,0,239.4,675.272Z",
    transform: "translate(-24.223 -460.981)",
    fill: "#346464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M377.308,466.9l-.278-1.494-5.934.713s-5.278.9-4.4,2.186c.743,1.093,3.705,1.925,5.363,2.841C373.765,469.684,375.543,468.3,377.308,466.9Z",
    transform: "translate(-179.269 -278.704)",
    fill: "#116a6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M369.712,332.939s-3.363-6.25-8.743-2.322.556,8.667.556,8.667a3.205,3.205,0,0,0,1.573,4.38c4.6,2.54,7.855-2.834,7.855-2.834A76.763,76.763,0,0,1,369.712,332.939Z",
    transform: "translate(-171.861 -150.772)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M392.39,310.729c-.013-.014-.028-.037-.048-.063a.008.008,0,0,0,0-.006c-.054-.075-.131-.184-.2-.283-.043-.06-.088-.126-.136-.2l-.021-.028c-.232-.326-.536-.745-.91-1.189a10.11,10.11,0,0,0-2.185-1.994,5.272,5.272,0,0,0-5.7-.221.3.3,0,1,0,.288.515,4.715,4.715,0,0,1,5.225.274q.116.079.225.16l.041.029A10.624,10.624,0,0,1,390.7,309.4c.39.462.693.885.9,1.184.33.472.408.471.642.418.143.1.231.036.257-.074a.291.291,0,0,0,0-.149C392.491,310.7,392.462,310.772,392.39,310.729Z",
    transform: "translate(-194.713 -128.868)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M494.907,181.41s5.608-1.458,6.6-4.422-.675-4.3-3.15-5.564c-1.322-1.216-5.345-3.816-9.943-1.66-5.384,2.525-5.927,8.58-2.607,16.4C486.932,188.807,494.907,181.41,494.907,181.41Z",
    transform: "translate(-289.393)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M509.425,422.23c-2.342.983-3.9-.819-5.854-2.784s-5.659-2.948-5.659-2.948,2.537-1.31,2.892-1.98-.258-7.109-.258-7.109a42.463,42.463,0,0,0,4.383,3.575,13.938,13.938,0,0,1,3.715,3.385,16.662,16.662,0,0,1,1.021,1.88C510.81,418.73,511.276,421.453,509.425,422.23Z",
    transform: "translate(-303.565 -224.181)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M581.732,479.6a6.225,6.225,0,0,1-6.326-5.278l1.905-.577a14.212,14.212,0,0,1,3.468,3.765A19.871,19.871,0,0,1,581.732,479.6Z",
    transform: "translate(-375.565 -286.545)",
    fill: "#143a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M521.367,296.419c-.177,1.177.075,9.786-5.083,10.541-2.566.375-6.079-1.534-7.559-4.305a14.882,14.882,0,0,1-.824-2.313s-2.689-.249-1.914-3.2c.38-1.446,1.832-1.985,2.584-1.18a5.442,5.442,0,0,1,.966,1.615,8.767,8.767,0,0,0,1.839-2.834.74.74,0,0,1,.7-.457c2.486.052,7.2-.171,8.652-1.819A10.444,10.444,0,0,1,521.367,296.419Z",
    transform: "translate(-310.175 -116.127)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M654.36,383.343a.369.369,0,0,0-.349-.127l-.046,0a.079.079,0,0,0-.017,0l-.016,0c-.466.083-.632.77-.432,1.131a.345.345,0,0,0,.135.215.378.378,0,0,0,.252.05.083.083,0,0,0,.023.009.458.458,0,0,0,.466-.318A.789.789,0,0,0,654.36,383.343Z",
    transform: "translate(-447.021 -201.402)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M643.266,337.81c-.374.239-.772.418-1.137.678s-.714.573-1.076.85c-.326.25-.054.77.275.517.362-.277.705-.588,1.076-.85s.763-.439,1.137-.678C643.885,338.107,643.61,337.59,643.266,337.81Z",
    transform: "translate(-437.139 -158.703)",
    fill: "#143a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M664.218,471.229a13.194,13.194,0,0,1-2.489-.175c-.072.534.049,2.2.935,2.182C663.811,473.217,664.218,471.229,664.218,471.229Z",
    transform: "translate(-454.756 -283.85)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623",
    transform: "translate(196.119 209.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M516.128,849.744s2.906,7.058,1.661,7.888-4.476-5.3-4.476-5.3Z",
    transform: "translate(-513.312 -849.744)",
    fill: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M370.122,517.311a9.866,9.866,0,0,0,3.909,1.741,14.541,14.541,0,0,1,8.577,4.6c2.393,2.526-8.56-2.914-8.56-2.914S370.75,519.709,370.122,517.311Z",
    transform: "translate(-182.585 -327.496)",
    fill: "#116a6a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625",
    transform: "translate(194.155 199.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M492.989,712.066a1.575,1.575,0,0,0-.393-.87,4.79,4.79,0,0,1-.57-1.191,7.547,7.547,0,0,1-.2-2.718c.118-.622.359-.839.263-.885a35.364,35.364,0,0,0-4.957-.743,8.019,8.019,0,0,0-3.551,2.069,38.553,38.553,0,0,0-2.914,2.914c-.729.729,1.821,6.193,1.821,6.193s1.785-1.177,2.443-1.616c.2-.13.387-.282.591-.4.52-.294,1.445-.024,2,.051a1.51,1.51,0,0,0,1.111-.155c.314-.234.423-.67.731-.911.525-.411,1.8-.051,2.009-.829a.266.266,0,0,1,.058-.133.219.219,0,0,1,.146-.041,3.4,3.4,0,0,0,.713-.068,1,1,0,0,0,.595-.374A.585.585,0,0,0,492.989,712.066Z",
    transform: "translate(-480.533 -703.681)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M610.2,757.151c-.139-.084-.276-.158-.362-.2a4,4,0,0,0-1.607-.27c-.207-.02-.447-.021-.454.161-.018.5.934.623,1.28.837.5.308,1.136.7,1.748,1.011A5.831,5.831,0,0,1,610.2,757.151Z",
    transform: "translate(-600.146 -751.635)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M611.076,726.926c.542.363,1.053,1.041,1.657,1.286.31.126.73.17.921-.1s.01-.644-.173-.923q-.558-.853-1.145-1.685a1.616,1.616,0,0,0-.618-.6,2.027,2.027,0,0,0-.948-.051,4.263,4.263,0,0,1-1.121-.073c-.223-.045-.5-.089-.638.09a.536.536,0,0,0-.076.357c.018.421.093.81.562.948A5.407,5.407,0,0,1,611.076,726.926Z",
    transform: "translate(-601.237 -721.613)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M587.66,724.552c-1-.6-2.107-.976-3.092-1.622-.321-.211-.72.239-.395.464a8.763,8.763,0,0,0,3.327,1.643A.258.258,0,0,0,587.66,724.552Zm-2.538,1.007c-.514-.184-1.046-.316-1.571-.464-.372-.1-.509.476-.14.582.524.151,1.046.319,1.579.432A.284.284,0,0,0,585.122,725.559Zm1.563-7.1c-.177,0-.639.011-1.318,0-.449-.006-.428.664.011.692a13.049,13.049,0,0,0,1.318.03A.362.362,0,0,0,586.685,718.463Z",
    transform: "translate(-577.04 -715.719)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M698.852,328.584c1.521,3.894,4.937,10.535,4.81,10.971s-4.665,2.939-5.685,2.876-5-10.753-4.816-11.226S698.852,328.584,698.852,328.584Z",
    transform: "translate(-688.313 -330.474)",
    fill: "#334a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M698.218,328.584c1.352,3.46,4.387,9.362,4.274,9.749s-4.145,2.611-5.052,2.556-4.445-9.555-4.279-9.975S698.218,328.584,698.218,328.584Z",
    transform: "translate(-687.727 -329.702)",
    fill: "#fafafa"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleTips3);
export default __webpack_public_path__ + "static/media/sale-tips-3.1e3784c745860ac56c431f1ee7964055.svg";
export { ForwardRef as ReactComponent };